import React from "react";
import "../PrivacyPolicy.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";
import {
  FiChevronRight,
  FiShield,
  FiLock,
  FiDatabase,
  FiGlobe,
  FiCheckCircle,
  FiMail,
  FiPhone,
  FiMapPin,
} from "react-icons/fi";

const PrivacyPolicy = () => {
  return (
    <>
      <Header />

      <div className="privacy-page">

        {/* =========================================
                    HERO
        ========================================= */}

        <section className="privacy-hero">

          <div className="container">

            <div className="privacy-hero-content">

              <span className="privacy-tag">
                PRIVACY POLICY
              </span>

              <h1>
                Protecting Your
                <span> Privacy & Data</span>
              </h1>

              <p>
                At <strong>Saivari Fintech Private Limited</strong>,
                protecting the confidentiality, integrity, and security
                of your information is one of our highest priorities.
                This Privacy Policy explains how we collect, use,
                protect, and manage your information while delivering
                secure fintech services.
              </p>

            </div>

          </div>

        </section>

        {/* =========================================
                    BREADCRUMB
        ========================================= */}

        <section className="privacy-breadcrumb">

          <div className="container">

            <Link to="/">Home</Link>

            <FiChevronRight />

            <span>Privacy Policy</span>

          </div>

        </section>

        {/* =========================================
                PRIVACY CONTENT
        ========================================= */}

        <section className="privacy-content">

          <div className="container">

            <div className="privacy-wrapper">

              {/* ----------------------------- */}

              <div className="privacy-card">

                <div className="privacy-icon">
                  <FiShield />
                </div>

                <h2>Introduction</h2>

                <p>
                  This Privacy Policy describes how Saivari Fintech
                  Private Limited collects, stores, processes, and
                  safeguards personal, business, and technical
                  information when you use our website, products,
                  services, or communicate with us.
                </p>

                <p>
                  By accessing our website or using our services,
                  you agree to the practices described in this policy.
                </p>

              </div>

              {/* ----------------------------- */}

              <div className="privacy-card">

                <div className="privacy-icon">
                  <FiDatabase />
                </div>

                <h2>Information We Collect</h2>

                <ul>

                  <li>
                    <FiCheckCircle />
                    Personal details such as name, email,
                    phone number, and company information.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Business and service enquiry information.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Technical information including browser,
                    IP address, device type, and operating system.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Website analytics and usage data.
                  </li>

                </ul>

              </div>

              {/* ----------------------------- */}

              <div className="privacy-card">

                <div className="privacy-icon">
                  <FiGlobe />
                </div>

                <h2>How We Use Your Information</h2>

                <ul>

                  <li>
                    <FiCheckCircle />
                    Deliver fintech consulting and technology services.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Respond to enquiries and provide support.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Improve our products and website performance.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Meet legal and regulatory obligations.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Maintain security and prevent fraud.
                  </li>

                </ul>

              </div>

              {/* ----------------------------- */}

              <div className="privacy-card">

                <div className="privacy-icon">
                  <FiLock />
                </div>

                <h2>Data Security</h2>

                <p>

                  We implement industry-standard security measures
                  including encryption, secure infrastructure,
                  controlled access, continuous monitoring, and
                  best security practices to protect sensitive
                  information from unauthorized access,
                  disclosure, alteration, or misuse.

                </p>

              </div>

              {/* ----------------------------- */}

              <div className="privacy-card">

                <div className="privacy-icon">
                  <FiShield />
                </div>

                <h2>Information Sharing</h2>

                <p>

                  We do not sell or rent personal information.
                  Information may only be shared with trusted
                  service providers, regulatory authorities,
                  or legal bodies when required by law or to
                  protect legitimate business interests.

                </p>

              </div>

              {/* ----------------------------- */}

              <div className="privacy-card">

                <div className="privacy-icon">
                  <FiDatabase />
                </div>

                <h2>Your Rights</h2>

                <ul>

                  <li>
                    <FiCheckCircle />
                    Request access to your information.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Request corrections or updates.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Request deletion where legally permitted.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Withdraw consent where applicable.
                  </li>

                  <li>
                    <FiCheckCircle />
                    Contact us regarding privacy concerns.
                  </li>

                </ul>

              </div>

              {/* ----------------------------- */}

              <div className="privacy-card">

                <div className="privacy-icon">
                  🍪
                </div>

                <h2>Cookies</h2>

                <p>

                  Our website may use cookies and analytics
                  technologies to improve functionality,
                  enhance user experience, understand website
                  usage, and optimize our services.
                  You may disable cookies through your browser
                  settings if preferred.

                </p>

              </div>

              {/* ----------------------------- */}

              <div className="privacy-card">

                <div className="privacy-icon">
                  🔄
                </div>

                <h2>Policy Updates</h2>

                <p>

                  We may update this Privacy Policy from time
                  to time to reflect regulatory changes,
                  technology improvements, or service updates.
                  Changes become effective immediately after
                  publication on this website.

                </p>

              </div>

              {/* ----------------------------- */}

              {/* <div className="privacy-contact">

                <h2>
                  Contact Us
                </h2>

                <p>
                  If you have questions regarding this Privacy
                  Policy or our data practices, please contact us.
                </p>

                <div className="privacy-contact-list">

                  <div>

                    <FiMail />

                    <span>
                      contact@saivarifintech.com
                    </span>

                  </div>

                  <div>

                    <FiPhone />

                    <span>
                      +91 XXXXX XXXXX
                    </span>

                  </div>

                  <div>

                    <FiMapPin />

                    <span>
                      Assam, India
                    </span>

                  </div>

                </div>

              </div> */}

            </div>

          </div>

        </section>

      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;